import Swal from 'sweetalert2';
export function Alerta(message:string, type:boolean) {
	const data = message;
	const Toast = Swal.mixin({
		toast: true,
		position: 'top-end',
		showConfirmButton: false,
		timer: 2500,
		timerProgressBar: true,
		didOpen: (toast) => {
			toast.addEventListener('mouseenter', Swal.stopTimer)
			toast.addEventListener('mouseleave', Swal.resumeTimer)
		}
	})

	if(type){
		Toast.fire({
			icon: 'success',
			title: message
		})
	}else {
		Toast.fire({
			icon: 'error',
			title: message
		})
	}
}
